'use client';

import { c as _c } from "react/compiler-runtime";
import { HotkeysProvider } from '@repo/shortcuts';
import type { ReactNode } from 'react';
import { GlobalShortcutGuard } from './_hooks/use-global-shortcut.ts';
import { CopyLoadDetailsSettingsCommands } from './copy-load-details-settings-commands.tsx';
import { CommandRegistryProvider } from './command-provider.tsx';
import { GlobalCmdK } from './global-cmdk.tsx';
import { GlobalShortcuts } from './global-shortcuts.tsx';
import { GodModeProvider } from './god-mode-provider.tsx';
export const CmdKShell = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <GlobalShortcutGuard data-sentry-element="GlobalShortcutGuard" data-sentry-source-file="cmdk-shell.tsx" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <GlobalShortcuts data-sentry-element="GlobalShortcuts" data-sentry-source-file="cmdk-shell.tsx" />;
    t3 = <CopyLoadDetailsSettingsCommands data-sentry-element="CopyLoadDetailsSettingsCommands" data-sentry-source-file="cmdk-shell.tsx" />;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <HotkeysProvider data-sentry-element="HotkeysProvider" data-sentry-component="CmdKShell" data-sentry-source-file="cmdk-shell.tsx">{t1}<CommandRegistryProvider data-sentry-element="CommandRegistryProvider" data-sentry-source-file="cmdk-shell.tsx"><GodModeProvider data-sentry-element="GodModeProvider" data-sentry-source-file="cmdk-shell.tsx"><GlobalCmdK data-sentry-element="GlobalCmdK" data-sentry-source-file="cmdk-shell.tsx">{t2}{t3}{children}</GlobalCmdK></GodModeProvider></CommandRegistryProvider></HotkeysProvider>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};